import { render, staticRenderFns } from "./QuickInvoiceView.vue?vue&type=template&id=6669934a"
import script from "./QuickInvoiceView.vue?vue&type=script&lang=js"
export * from "./QuickInvoiceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6669934a')) {
      api.createRecord('6669934a', component.options)
    } else {
      api.reload('6669934a', component.options)
    }
    module.hot.accept("./QuickInvoiceView.vue?vue&type=template&id=6669934a", function () {
      api.rerender('6669934a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quickinvoice/QuickInvoiceView.vue"
export default component.exports